const printDate = (date: string): string => {
  const currDate = new Date(date);

  return `${currDate.getDate()}/${
    currDate.getMonth() + 1
  }/${currDate.getFullYear()} at ${
    currDate.getHours().toString().length === 1
      ? "0" + currDate.getHours()
      : currDate.getHours()
  }:${
    currDate.getMinutes().toString().length === 1
      ? "0" + currDate.getMinutes()
      : currDate.getMinutes()
  }`;
};

export default printDate;
